<template lang="pug">
    header#masthead.site-header
        nav.navbar.navbar-expand-lg.p-0.mt-2.mt-sm-4
            button.navbar-toggler.ml-auto.mr-sm-4(type='button', data-toggle='collapse', data-target='#navbarTopContent', aria-controls='navbarTopContent', aria-expanded='false', aria-label='Toggle navigation')
                i.menu-icon
            nav#navbarTopContent.collapse.navbar-collapse.ml-auto.d-lg-flex.justify-content-lg-end
                ul.navbar-nav.mr-lg-5
                    li.nav-item(v-for='mi in topMenu' :class='getLiClasses(mi)')
                        a.dropdown-toggle.nav-link(v-if='mi.children.length !== 0' data-toggle="dropdown" aria-haspopup="true" aria-expanded="true") {{ mi.title }}
                        a.nav-link(v-else :href='mi.url') {{ mi.title }}
                        ul.dropdown-menu(v-if='mi.children.length !== 0')
                            li.nav-item(v-for='smi in mi.children')
                                a.nav-link(:href='smi.url') {{ smi.title }}
</template>

<script>
import menuService from '@/ws/menu'

export default {
 data(){
     return {
         topMenu: {
            "5": {
        "title": "Ortografía Cerebral",
        "url": "#oc",
        "classes": [
            "d-lg-none"
        ],
        "children": []
    },
    "7": {
        "title": "Ortografía Financiera",
        "url": "#of",
        "classes": [
            "d-lg-none"
        ],
        "children": []
    },
    "8": {
        "title": "Ortografía Empresarial",
        "url": "#oe",
        "classes": [
            "d-lg-none"
        ],
        "children": []
    },
    "9": {
        "title": "Ortografía",
        "url": "",
        "classes": [
            "d-none",
            "d-lg-block"
        ],
        "children": {
            "10": {
                "title": "Cerebral",
                "url": "#oc",
                "classes": [
                    ""
                ]
            },
            "11": {
                "title": "Financiera",
                "url": "#of",
                "classes": [
                    ""
                ]
            },
            "12": {
                "title": "Empresarial",
                "url": "#oe",
                "classes": [
                    ""
                ]
            }
        }
    },
    "13": {
        "title": "Mujeres Adas",
        "url": "#ma",
        "classes": [
            ""
        ],
        "children": []
    },
    "14": {
        "title": "Consultas",
        "url": "#ap",
        "classes": [
            ""
        ],
        "children": []
    },
    "15": {
        "title": "Eventos",
        "url": "#ev",
        "classes": [
            ""
        ],
        "children": []
    },
    "16": {
        "title": "Instructores",
        "url": "#in",
        "classes": [
            ""
        ],
        "children": []
    },
    "17": {
        "title": "Sobre la Autora",
        "url": "#au",
        "classes": [
            ""
        ],
        "children": []
    },
    "18": {
        "title": "Testimonios",
        "url": "#te",
        "classes": [
            ""
        ],
        "children": []
    } 
         }
     }
 },
 methods: {
     getLiClasses($item){
         let $classValue = $item.children.length !== 0 ? 'dropdown' : '';
         $classValue += $item.classes.length === 0 ? '' : ' ' + $item.classes.join(' '); 
         return $classValue;
     }
 },
//  beforeCreate() {
//      menuService.topMenu()
//         .then(res => this.topMenu = res)
//  } 
    mounted () {
        this.$nextTick( () => {
            $('.navbar-collapse a').click(function(){
                $('.navbar-collapse').collapse('hide');
            });
        })
    }
}
    </script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue